export const NAME_FIELD_PLACEHOLDER = 'e.g Hero Description';
